export const toCamelCase = (string: string): string => {
  const words = string.trim().split(' ');
  const firstWord = words[0].toLowerCase();
  const restWords = words.slice(1);

  const camelCaseWords = restWords.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

  return firstWord + camelCaseWords.join('');
};
